import { ViaCepResponse } from '../types';

export async function viaCepSearch(cep: string): Promise<ViaCepResponse> {
  const cleanCep = cep.replace(/\D/g, '');

  if (cleanCep.length !== 8) {
    throw new Error('Invalid CEP format');
  }

  try {
    const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);

    if (!response.ok) {
      throw new Error('ViaCEP API request failed');
    }

    const data = await response.json();

    if (data.erro) {
      throw new Error('CEP not found');
    }

    return data;
  } catch (error) {
    console.error('Error fetching CEP data:', error);
    throw error;
  }
}
